module.exports = __webpack_public_path__ + "img/meltme_200.73f01428.jpg";